// src/styles/configStyles.js
import { createGlobalStyle } from 'styled-components';

export const ConfigStyles = createGlobalStyle`
  /* Override button focus styles */
  input:focus, textarea:focus, select:focus {
    border-color: ${props => props.primary};
    box-shadow: 0 0 0 3px ${props => props.primary}30;
  }
  
  /* Override alert box colors */
  .alert-box.info {
    border-left-color: ${props => props.primary};
  }
  
  /* Override file upload label hover */
  input[type="file"] + label:hover {
    border-color: ${props => props.primary};
  }
  
  /* Override checkbox and radio checked state */
  input[type="radio"]:checked, input[type="checkbox"]:checked {
    accent-color: ${props => props.primary};
  }
`;